export function firstOrNull<T>(array: T[] | null): T | null {
  if (array && array.length > 0) {
    return array[0];
  }
  return null;
}
